"use strict";function quickCallList$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.quickCallList$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.telephone.quickCallList";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"3.5.6"},_a[ddSdk_1.ENV_ENUM.ios]={vs:"3.5.6"},_a[ddSdk_1.ENV_ENUM.android]={vs:"3.5.6"},_a)),exports.quickCallList$=quickCallList$,exports.default=quickCallList$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/telephone/quickCallList.js
// module id = 996
// module chunks = 106